import React from 'react';
import { CheckIcon } from 'lucide-react';
import { INCLUDES_KICKER, systemIncludes } from '../data/sushiContent';
export function IncludesSection() {
  return <section className="w-full bg-charcoal-950 py-12 sm:py-16" aria-labelledby="includes-title" data-id="element-177" data-mp="2dsltwyqs6a6r">
      <div className="mx-auto max-w-3xl px-5" data-id="element-178" data-mp="240g2pr8crwsm">
        <div className="border border-champagne/25 bg-charcoal-900 px-6 py-8 sm:px-10" data-id="element-179" data-mp="23zn6hk70spoq">
          <p className="text-[10px] font-semibold uppercase tracking-[0.32em] text-champagne" data-id="element-180" data-mp="1z2ej9570lvgm">
            Ebook principal — 90 páginas
          </p>
          <h2 id="includes-title" className="mt-3 font-display text-xl font-semibold uppercase tracking-wide text-ivory-50 sm:text-2xl" data-id="element-181" data-mp="1v24flz6p3h4x">
            Lo que incluye por dentro:
          </h2>
          <ul className="mt-5 grid gap-2.5 sm:grid-cols-2" data-id="element-182" data-mp="3kf7xubwvvi5m">
            {systemIncludes.map(item => <li key={item} className="flex items-start gap-2.5" data-id="element-183" data-mp="3ffbsa88jfiny">
                <CheckIcon className="mt-1 h-3.5 w-3.5 shrink-0 text-champagne" strokeWidth={3} aria-hidden="true" data-id="element-184" data-mp="3ugrzxgkl5tkm" />
                <span className="text-[14px] leading-snug text-ivory-200" data-id="element-185" data-mp="2av8nk0www35">{item}</span>
              </li>)}
          </ul>
          <p className="mt-7 border-t border-charcoal-600 pt-5 font-display text-lg italic text-champagne" data-id="element-186" data-mp="3ph5lx4wxo9ar">
            {INCLUDES_KICKER}
          </p>
        </div>
      </div>
    </section>;
}